// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h5tA","right":"styles_right__upj75"};